import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from 'react';
import {
  BaseSpecialPrickIdGetCustomerDto,
  BaseSpecialPrickIdGetMaterialDto,
  SearchSpecialPrickHeaderTableDataDto,
  SpecialPriceApprovalTableProp,
  SpecialPriceApprovalTableRef,
} from '@/pages/specialPriceTable/specialPriceApproval/components/specialPriceApprovalTable/type';
import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { BaseTextFieldSize } from '@/styles';
import { ApprovalNodeTypeEnum } from '@/services/api/specialPriceTable/types';
import TablePaginationActions from '@/components/priceDialog/TablePaginationActions';

const SpecialPriceApprovalTable:
    ForwardRefRenderFunction<SpecialPriceApprovalTableRef, SpecialPriceApprovalTableProp> =
    (props, ref) => {
      const [headerList, setHeaderList] = useState<SearchSpecialPrickHeaderTableDataDto[]>([]);
      const [customerList, setCustomerList] = useState<BaseSpecialPrickIdGetCustomerDto[]>([]);
      const [materialList, setMaterialList] = useState<BaseSpecialPrickIdGetMaterialDto[]>([]);
      const { ApprovalButton, HeaderClick, handleChangePage, handleChangeRowsPerPage, page, headerTotal } = props;

      useImperativeHandle(ref, () => {
        return ({
          LoadHeader(HeaderList: SearchSpecialPrickHeaderTableDataDto[]) {
            setHeaderList(HeaderList);
            setCustomerList([]);
            setMaterialList([]);
          },
          LoadItem(CustomerList: BaseSpecialPrickIdGetCustomerDto[], MaterialList: BaseSpecialPrickIdGetMaterialDto[]) {
            setCustomerList(CustomerList);
            setMaterialList(MaterialList);
          },
        });
      });

      function headerListCheckedNull(inList: SearchSpecialPrickHeaderTableDataDto[]) {
        if (inList.length > 0) {
          return headerList.map((row) => (
                    <TableRow key={row.SpecialPrickId}
                              onClick={() => HeaderClick(row.SpecialPrickId)}>
                        <TableCell>{row.TypeDescription}</TableCell>
                        <TableCell>{row.LanguageDescription}</TableCell>
                        <TableCell>{row.WhetherToSubmitDate}</TableCell>
                        <TableCell>{row.SalesName}</TableCell>
                        <TableCell>{row.SalesPhone}</TableCell>
                        <TableCell>{row.SalesOfficeHours}</TableCell>
                    </TableRow>
          ));
        } else {
          return (
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
          );
        }
      }

      function customerListCheckedNull(inList: BaseSpecialPrickIdGetCustomerDto[]) {
        if (inList.length > 0) {
          return customerList.map((row) => (
                    <TableRow key={row.Id}>
                        <TableCell>{row.SoNumber}</TableCell>
                        <TableCell>{row.CustomerId}</TableCell>
                        <TableCell>{row.CustomerName}</TableCell>
                        <TableCell>{row.PersonReceivingTheDocument}</TableCell>
                        <TableCell>{row.DoorNumberStreet}</TableCell>
                        <TableCell>{row.City}</TableCell>
                        <TableCell>{row.Province}</TableCell>
                        <TableCell>{row.PostCode}</TableCell>
                    </TableRow>
          ));
        } else {
          return (
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
          );
        }
      }

      function materialListCheckedNull(inList: BaseSpecialPrickIdGetMaterialDto[]) {
        if (inList.length > 0) {
          return materialList.map((row) => (
                    <TableRow key={row.Id}>
                        <TableCell>{row.MaterialNumber}</TableCell>
                        <TableCell>{row.MaterialDescription}</TableCell>
                        <TableCell>{row.CustomItem}</TableCell>
                        <TableCell>{row.Cost}</TableCell>
                        <TableCell>{row.CustomCost}</TableCell>
                        <TableCell>{row.ApprovalTypeDesc}</TableCell>
                        <TableCell align="right" width={160}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  ApprovalButton({
                                    SpecialPrickMaterialInformationIdList: [row.Id],
                                    ApprovalType: ApprovalNodeTypeEnum.End,
                                  });
                                }}
                            >
                                通過
                            </Button>

                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  ApprovalButton({
                                    SpecialPrickMaterialInformationIdList: [row.Id],
                                    ApprovalType: ApprovalNodeTypeEnum.Reject,
                                  });
                                }}
                            >
                                駁回
                            </Button>
                        </TableCell>
                    </TableRow>
          ));
        } else {
          return (
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">
                            <Button
                                variant="outlined"
                                color="secondary"
                            >
                                通過
                            </Button>

                            <Button
                                variant="outlined"
                                color="secondary"
                            >
                                駁回
                            </Button>
                        </TableCell>
                    </TableRow>
          );
        }
      }

      return (
            <Box>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table aria-label="MaterialTable" size={BaseTextFieldSize} width={'100%'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>類型</TableCell>
                                        <TableCell>語言</TableCell>
                                        <TableCell>是否提交日期</TableCell>
                                        <TableCell>銷售人</TableCell>
                                        <TableCell>銷售電話</TableCell>
                                        <TableCell>上班時間</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        headerListCheckedNull(headerList)
                                    }
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 20, 30]}
                                            count={headerTotal}
                                            // 每页的行数
                                            rowsPerPage={page.Limit}
                                            // 第几页,从0开始索引
                                            page={page.Page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={5}>
                        <TableContainer>
                            <Table aria-label="MaterialTable" size={BaseTextFieldSize}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>So</TableCell>
                                        <TableCell>客戶編號</TableCell>
                                        <TableCell>客戶描述</TableCell>
                                        <TableCell>收表人</TableCell>
                                        <TableCell>門牌+街道</TableCell>
                                        <TableCell>城市</TableCell>
                                        <TableCell>所在州</TableCell>
                                        <TableCell>郵編</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        customerListCheckedNull(customerList)
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={7}>
                        <TableContainer>
                            <Table aria-label="MaterialTable" size={BaseTextFieldSize}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>物料號</TableCell>
                                        <TableCell>物料描述</TableCell>
                                        <TableCell>自定義ITEM</TableCell>
                                        <TableCell>SJ COST</TableCell>
                                      <TableCell>SJ市場價</TableCell>
                                        <TableCell>当前审批状态</TableCell>
                                        <TableCell align={'right'}>審批操作</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        materialListCheckedNull(materialList)
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={10}></Grid>
                    <Grid item xs={2} container justifyContent={'flex-end'} alignItems={'flex-end'}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  ApprovalButton({
                                    SpecialPrickMaterialInformationIdList: materialList.map(p => p.Id),
                                    ApprovalType: ApprovalNodeTypeEnum.End,
                                  });
                                }}
                            >
                                一键通过
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  ApprovalButton({
                                    SpecialPrickMaterialInformationIdList: materialList.map(p => p.Id),
                                    ApprovalType: ApprovalNodeTypeEnum.Reject,
                                  });
                                }}
                            >
                                一键驳回
                            </Button>
                    </Grid>
                    <Grid item xs={12}></Grid>
                </Grid>
            </Box>
      );
    }
;

export default forwardRef(SpecialPriceApprovalTable);
